import { FC, ReactNode, useCallback } from 'react';
import { CopyToClipboardWithNotifier } from '@edikk-edikk/copy-to-clipboard';
import { useIntl } from 'react-intl';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const GalleryHeaderShare: FC = () => {
  const {
    advert: {
      url,
      name,
    },
  } = useAdvertDetailContext();
  const intl = useIntl();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  const isAvailableShare = () => typeof navigator !== 'undefined' && 'share' in navigator;

  const handlerClick = useCallback(async () => {
    await navigator.share({ url, title: name }).catch(() => null);
  }, [name, url]);

  const wrap = useCallback((node: ReactNode): ReactNode => {
    if (isAvailableShare()) {
      return node;
    }

    return (
      <CopyToClipboardWithNotifier
        text={url}
        message={intl.formatMessage({ defaultMessage: 'Link copied' })}
      >
        {node}
      </CopyToClipboardWithNotifier>
    );
  }, [intl, url]);

  return wrap((
    <Button
      variant={isFrontendStyleDefault ? ButtonVariant.black : ButtonVariant.blackRose}
      size={ButtonSize.lg}
      circle
      onClick={handlerClick}
      aria-label="Share"
    >
      <AppSvgSpriteMonoIcon name="arrow" />
    </Button>
  ));
};

export { GalleryHeaderShare };
